import { render, staticRenderFns } from "./arrivalAdmin.vue?vue&type=template&id=7b8f9db2"
import script from "./arrivalAdmin.vue?vue&type=script&lang=js"
export * from "./arrivalAdmin.vue?vue&type=script&lang=js"
import style0 from "./arrivalAdmin.vue?vue&type=style&index=0&id=7b8f9db2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports